var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcContact16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7 5a1 1 0 1 0 1.998.002A1 1 0 0 0 7 5M5 5a3 3 0 1 0 6 0 3 3 0 1 0-6 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 11a3 3 0 0 0-2.836 2.018C4.984 13.54 4.552 14 4 14s-1.01-.452-.901-.994a5.002 5.002 0 0 1 9.802 0c.11.542-.349.994-.901.994s-.984-.46-1.164-.982A3 3 0 0 0 8 11"
})));
export default SvgIcContact16;